import { estimatePlan } from '@weft/services';
import type { Currency, Plan } from '@weft/types';
import { isNotEmptyArray } from '@weft/utils';
import { usePlanCharges } from 'apps/app/src/hooks/use-plan-charges';
import { getSplitVolumeUsageProducts } from 'apps/app/src/utils/get-split-usage-products';
import React from 'react';
import { Price } from '../../../../components/design/Price';
import { useUsageProductsOrder } from '../../../../hooks/use-usage-products-order';
import { CreatePlanSection } from '../../CreatePlanPage/create-plan-page-components/CreatePlanSection';
import { FixedCharges } from '../../CreatePlanPage/create-plan-page-components/FixedCharges/FixedCharges';
import { PlanChargesContainer } from '../../CreatePlanPage/create-plan-page-components/PlanChargesContainer';
import { PromotionCharges } from '../../CreatePlanPage/create-plan-page-components/PromotionCharges/PromotionCharges';
import { UsageCharges } from '../../CreatePlanPage/create-plan-page-components/UsageCharges/UsageCharges';

type PlanChargesProps = {
  plan: Plan;
  currency: Currency;
};

export const PlanCharges: React.FC<PlanChargesProps> = ({ plan, currency }) => {
  const { fixedProducts, usageProducts, promotions } = usePlanCharges(plan);
  const { nonVolumeBasedProducts, volumeBasedProducts } = getSplitVolumeUsageProducts(usageProducts);
  const [usageProductsOrder] = useUsageProductsOrder(nonVolumeBasedProducts);

  return (
    <div className="mt-12 w-full space-y-12">
      {isNotEmptyArray(fixedProducts) && (
        <FixedCharges
          fixedProducts={fixedProducts}
          currency={currency}
        />
      )}
      {isNotEmptyArray(nonVolumeBasedProducts) && (
        <UsageCharges {...{ order: usageProductsOrder, usageProducts: nonVolumeBasedProducts, editable: false, billingInterval: plan.billingData.billingInterval, currency }} />
      )}
      {isNotEmptyArray(volumeBasedProducts) && (
        <UsageCharges {...{ order: new Set(['Volume']), usageProducts: volumeBasedProducts, sectionTitle: 'Usage Fees - Volume pricing', editable: false, billingInterval: plan.billingData.billingInterval, currency }} />
      )}
      {isNotEmptyArray(promotions) && (
        <PromotionCharges
          promotions={promotions}
          editable={false}
          currency={currency}
        />
      )}
      <CreatePlanSection
        title='Estimated value'
        hideCreateAnother
      >
        <PlanChargesContainer
          className='p-8 shadow-[0px_10px_24px_0px_rgba(0,0,0,0.03)]'
        >
          <div className="flex items-center justify-between">
            <p className='text-lg text-black'>Total Yearly Estimation</p>
            <Price
              className='text-base text-black'
              currency={currency}
            >
              {estimatePlan(plan)}
            </Price>
          </div>
        </PlanChargesContainer>
      </CreatePlanSection>
    </div>
  );
};